import ApiService from "@/services/api.service";

class GearError extends Error {
  constructor(errorCode, message) {
    super(message);
    this.name = this.constructor.name;
    this.message = message;
    this.errorCode = errorCode;
  }
}

const buildGearError = (error, fallbackMessage) => {
  const status = error && error.response ? error.response.status : null;
  const data = error && error.response ? error.response.data : null;
  const message =
    (data && (data.detail || data.message || data.error)) ||
    error.message ||
    fallbackMessage;
  return new GearError(status, message);
};

const GearService = {
  listBoards: async function() {
    try {
      const response = await ApiService.get("/matos/planches/utilisables");
      return response;
    } catch (error) {
      throw buildGearError(error, "Impossible de charger les planches.");
    }
  },

  listSails: async function() {
    try {
      const response = await ApiService.get("/matos/voiles/utilisables");
      return response;
    } catch (error) {
      throw buildGearError(error, "Impossible de charger les voiles.");
    }
  },

  listAllBoards: async function() {
    try {
      const response = await ApiService.get("/matos/planches");
      return response;
    } catch (error) {
      throw buildGearError(error, "Impossible de charger les planches.");
    }
  },

  listAllSails: async function() {
    try {
      const response = await ApiService.get("/matos/voiles");
      return response;
    } catch (error) {
      throw buildGearError(error, "Impossible de charger les voiles.");
    }
  }
};

export default GearService;

export { GearService, GearError };
